export default __webpack_public_path__ + "images/procter-gamble-logo.2618d476d10696b87e210f9cc3985686.png";